module.exports = "/_next/static/images/DataPipeline@2x-6ae702dcc4e49401e45d180d731f8933.png";